import { ShopsMapModelExt } from '@models/Header/IShopModel';
import { DeliveryType } from '@app/entities/Delivery';
import { ShopType } from '@entities/Shop';

export const sortAvailable = (shop1, shop2) => shop1.available - shop2.available;

export const sortPartner = (shop1: ShopsMapModelExt, shop2: ShopsMapModelExt) => shop1.partnerType - shop2.partnerType;

export const sortByDistance = (shop1, shop2) => {
  if (shop1?.distance && shop2?.distance) {
    return +shop1?.distance - +shop2?.distance;
  } else {
    return 0;
  }
};

export const sortDelivery = a => {
  if (a.code === DeliveryType.Pickup) {
    return -1;
  }
  if (a.code === DeliveryType.TK) {
    return 1;
  }
};

export const sortByStatusDelivery = (a: ShopType, b: ShopType) => {
  if (a.statusDeliveryToday || a.statusDeliveryToday === 0) {
    return -1;
  } else if (b.statusDeliveryNoToday) {
    return 1;
  }
};

export const sortListConstructorReviews = (a, b) => a.sort - b.sort;
